function OurGenesis() {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-8">
          Our Genesis
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6">
          On March 2005 the foundation stone of Capitol Public School was laid.
          We started working from 5th June 2006. The school began with
          pre-primary section and one section from Class I to V.
        </p>

        <p className="text-gray-700 leading-relaxed mb-10">
          Over the years, new grades and sections were added to match the
          growing number of students and the institution’s steady progress.
        </p>

        {/* Mission */}
        <div className="bg-white p-6 rounded-xl shadow mb-6">
          <h2 className="text-2xl font-bold text-yellow-500 mb-3">
            Our Mission
          </h2>
          <p className="text-gray-700">
            To impart value-based quality education with an analytical approach,
            enabling students to convert knowledge into wisdom and become
            responsible human beings.
          </p>
        </div>

        {/* Vision */}
        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="text-2xl font-bold text-yellow-500 mb-3">
            Our Vision
          </h2>
          <p className="text-gray-700 font-semibold">
            “Building a New Generation”
          </p>
        </div>

      </div>
    </section>
  );
}

export default OurGenesis;